export const iconFontAwesomeShoppingTruck = (
	<i className="fa-solid fa-truck"></i>
);
